/**
 * "7h 42m" / "42m" / "0m". Floors to whole minutes: totals stay exact in
 * milliseconds on the server and are only rounded here, at the edge.
 */
export function formatDuration(ms) {
    const totalMinutes = Math.max(0, Math.floor(ms / 60_000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
}
//# sourceMappingURL=duration.js.map